import store from '../store'

export default function hasRanking() {
    let clients = store.getters['params/clients']
    let id_user_client_selected = store.getters['common/id_user_client_selected']

    if (id_user_client_selected) {
        let obj = clients.find((obj) => { return obj.id === id_user_client_selected })
        if(obj) return obj.has_ranking
        else return true
    }
    else return true 
}
